// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuViewHeader_container__1W8hX","title":"MenuViewHeader_title__UdYNo","closeIcon":"MenuViewHeader_closeIcon__3PrZ0","backIcon":"MenuViewHeader_backIcon__3d5PB"};